import { render, staticRenderFns } from "./wuyeProjectInfo.vue?vue&type=template&id=48b1c6b0&scoped=true&"
import script from "./wuyeProjectInfo.vue?vue&type=script&lang=js&"
export * from "./wuyeProjectInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b1c6b0",
  null
  
)

export default component.exports